export default `
## Wat zijn cookies?
Cookies zijn stukjes data die u genereert bij uw interactie met websites op het internet. Ze helpen websites te onthouden wie u bent en een profiel over u op te bouwen waarmee bedrijven u beter volgen, met name wat uw taalvoorkeur of inloggegevens betreft. 

Op deze pagina vindt u informatie over de verschillende soorten cookies en waarbij ze ons helpen.

<div id="ot-sdk-cookie-policy"></div>
</br>
<button id="ot-sdk-btn" class="ot-sdk-show-settings"></button>

## Meer informatie
Hopelijk heeft dit een en ander voor u verduidelijkt en zoals eerder vermeld als er iets is waarvan u niet zeker bent of u het nodig hebt of niet, is het meestal veiliger om cookies ingeschakeld te laten voor het geval er interactie is met een van de functies die u op onze site gebruikt. Als u echter nog steeds op zoek bent naar meer informatie, kunt u contact met ons opnemen via een van onze favoriete contactmiddelen.

Email: [$supportEmail](mailto:$supportEmail)

## Hoe beheert u uw cookies
Om informatie over andere browsers te vinden, raadpleeg de website van de browser developer.

Google Chrome [Klik hier](https://support.google.com/accounts/answer/61416?co=3DGENIE.Platform==Desktop&hl=3Den)

Microsoft Edge [Klik hier](https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy)

Mozilla Firefox [Klik hier](https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences)

Apple Safari [Klik hier](https://support.apple.com/kb/ph21411?locale=3Den_US)

Opera [Klik hier](https://www.opera.com/help/tutorials/security/privacy/)

Microsoft Internet Explorer [Klik hier](https://support.microsoft.com/en-gb/help/17442/windows-internet-explore=r-delete-manage-cookies)

Om niet meer door Google Analytics gevolgd te worden op alle websites, klik op [Google Analytics Uitschakelen](http://tools.google.com/dlpage/gaoptout).
U kunt uw cookies beheren via uw webbrowser. U kunt meer informatie vinden op de website van de [Autoriteit Persoonsgegevens](https://autoriteitpersoonsgegevens.nl/nl/onderwerpen/internet-telefoon-tv-en-post/cookies).


`;
